import React, { useState } from 'react';
import './TutorialModal.css';

const TutorialModal = ({ isOpen, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const guideSteps = [
    {
      title: "Step 1: Muatkan Senarai Pelajar",
      text: "Semendapatkan data TAHUN dengan klik Muatkan Senarai Pelajar",
      image: "/img/guide-step1.png"
    },
    {
      title: "Step 2: Salin Jadual",
      text: "Anda boleh salin data dan tampalkannya ke dalam Excel untuk kegunaan selanjutnya.",
      image: "/img/guide-step2.png"
    },
    {
      title: "Step 3: Tampalkan rekod Pelajar ke Excel",
      text: "Tampalkan rekod Pelajar ke Excel",
      image: "/img/guide-step3.png"
    },
    {
      title: "Step 4: Kemasukan Data dalam Excel",
      text: "Kemasukan Data dalam Excel",
      image: "/img/guide-step4.png"
    },
    {
      title: "Step 5: Salin Data Daripada Excel",
      text: "Salin Data Daripada Excel",
      image: "/img/guide-step5.png"
    },
    {
      title: "Step 6: Import Pelajar",
      text: "Tampal Data ke Tetingkap Import.",
      image: "/img/guide-step6.PNG"
    },
    {
      title: "Step 7: ",
      text: "Tambah dan Alih keluar rekod pelajar",
      image: "/img/guide-step7.PNG"
    },
    {
      title: "Step 8: Simpan & Hantar",
      text: "Simpan: Simpan sebagai Draf. Hantar: Lengkap dan Hantar",
      image: "/img/guide-step8.PNG"
    },
    {
      title: "Step 9: School Report",
      text: "School Report",
      image: "/img/guide-step9.PNG"
    }
  ];

  if (!isOpen) return null;

  const currentStepData = guideSteps[currentStep];
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === guideSteps.length - 1;

  const handlePrevious = () => {
    if (!isFirstStep) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleNext = () => {
    if (!isLastStep) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleClose = () => {
    setCurrentStep(0);
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('tutorial-overlay')) {
      handleClose();
    }
  };

  return (
    <div className="tutorial-overlay" onClick={handleOverlayClick}>
      <div className="tutorial-modal">
        <button className="tutorial-close-btn" onClick={handleClose}>
          &times;
        </button>

        <h2 className="tutorial-title">{currentStepData.title}</h2>

        <div className="tutorial-content">
          <div className="tutorial-text">{currentStepData.text}</div>
          <img
            src={currentStepData.image}
            alt={currentStepData.title}
            className="tutorial-image"
          />
        </div>

        <div className="tutorial-buttons">
          <button
            className="tutorial-btn tutorial-btn-prev"
            onClick={handlePrevious}
            style={{ display: isFirstStep ? 'none' : 'inline-block' }}
          >
            Back
          </button>
          <button
            className="tutorial-btn tutorial-btn-next"
            onClick={handleNext}
            style={{ display: isLastStep ? 'none' : 'inline-block' }}
          >
            Next
          </button>
          <button
            className="tutorial-btn tutorial-btn-close"
            onClick={handleClose}
            style={{ display: isLastStep ? 'inline-block' : 'none' }}
          >
            Close
          </button>
        </div>

        <div className="tutorial-step-indicator">
          Step {currentStep + 1} of {guideSteps.length}
        </div>
      </div>
    </div>
  );
};

export default TutorialModal;
